// extracted by mini-css-extract-plugin
export default {"selectedItem":"Home_selectedItem__2Au75"};